import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actionsMetrics from '../../action-creators/metrics';

export const PageElementFactory = (element, apaAssets) => {
  switch (element.type) {
    case 'image': {
      const srcImgP =
        apaAssets[element.image.portrait] ||
        '/webclient/sk_core/images/portrait.png';
      const srcImgL =
        apaAssets[element.image.landscape] ||
        '/webclient/sk_core/images/landscape.png';

      return (
        <div>
          <div className="col-md-12 visible-md visible-lg img-responsive ">
            <img
              src={srcImgL}
              alt="whats new imagen"
              className="center-block img-resize"
              style={styles}
            />
          </div>
          <div className="col-xs-12 visible-sm visible-xs img-responsive">
            <img
              src={srcImgP}
              alt="whats new imagen"
              className="center-block"
              style={styles}
            />
          </div>
        </div>
      );
    }
    case 'text':
      return <div> TEXTO </div>;
    default:
      return <div>undefined</div>;
  }
};

const styles = {
  padding: '10px 0',
};

// GRACIAS ABEL
const setMetrics = props => {
  props.setMetricsEvent({
    tagManager: {
      event: 'virtualPageView',
      virtualPageUrl: `whats-informativo-${props.index}`,
      vrtualPageTitle: `whats-informativo-${props.index}`,
    },
  });

  props.setMetricsEvent({
    type: 'executor',
    success: true,
  });
};

class PageWhatsNew extends Component {
  // TODO: REFACTOR -> Change UNSAFE_componentWillReceiveProps to componentDidUpdate

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      setMetrics(nextProps);
    }
  }

  render() {
    return (
      <div>
        {this.props.page.map(p => PageElementFactory(p, this.props.apaAssets))}
      </div>
    );
  }
}

PageWhatsNew.propTypes = {
  page: PropTypes.arrayOf(PropTypes.shape({})),
  apaAssets: PropTypes.shape({}),
};

const mapDispatchToProps = {
  setMetricsEvent: actionsMetrics.setMetricsEvent,
};

export default connect(
  null,
  mapDispatchToProps,
)(PageWhatsNew);
